import { useMemo } from 'react'
import { isValid, isBefore } from 'date-fns'

export function useIsDisabled(props) {
  return useMemo(
    () =>
      !isValid(props.currentValue?.from) ||
      !isValid(props.currentValue?.to) ||
      isBefore(props.currentValue?.to, props.currentValue?.from),
    [props.currentValue?.to, props.currentValue?.from]
  )
}

export function useOnConfirmClick(props) {
  return function onClick() {
    props.onSave()
    props.closePopover && props.closePopover()
  }
}
